export default {
  offerDocs(state) {
    return state.offerDocs.filter((offerDoc) => offerDoc.viewAgreementCheckbox)
  },
}
